import { render } from "./Landing.vue?vue&type=template&id=4b946cc2&scoped=true"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=4b946cc2&scoped=true&lang=css"

import exportComponent from "/opt/FE_Compro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b946cc2"]])

export default __exports__